@if (type) {
  <div class="unavailable-container">
    <ion-icon name="{{icon}}" class="unavailable-container__icon"></ion-icon>
    <div class="rtf unavailable-container__message" [innerHTML]="message"></div>

    @if (type == 'error') {
      <ion-button class="proto-button unavailable-container__button" expand="block" (click)="refresh.emit()">
        {{ 'BUTTON.RELOAD' | translate }}
      </ion-button>
    }

    <ng-content select=".unavailable-content"></ng-content>
  </div>
}
